import { CommonUtils } from "../../../util/common-utils";
import type { NavbarHamburgerForm } from "./navbar-hamburger-form";

export class NavbarHamburgerHandler {
    public form: NavbarHamburgerForm;

    public constructor(form: NavbarHamburgerForm) {
        this.form = form;
    }

    public bootstrap(): void {
        this.syncByViewport();
    }

    public handleToggleClick(event: Event): void {
        event.preventDefault();
        const next = !this.form.isExpanded();
        this.form.setExpanded(next);
    }

    public handleEscapeKey(event: KeyboardEvent): void {
        if (event.key !== "Escape") return;
        if (!this.form.isExpanded()) return;
        this.form.setExpanded(false);
    }

    public handleDocumentClick(event: Event): void {
        if (!this.form.isExpanded()) return;
        if (!this.isMobileViewport()) return;

        const target = event.target;
        if (!(target instanceof Element)) return;

        const root = this.form.getRoot();
        if (root.contains(target)) return;

        this.form.setExpanded(false);
    }

    public handleOverlayClick(): void {
        this.form.setExpanded(false);
    }

    public handleCollapsibleClick(event: Event): void {
        const link = this.form.getLinkTarget(event.target);
        if (!(link instanceof HTMLAnchorElement)) return;

        if (!this.form.isExpanded()) return;
        if (!this.isMobileViewport()) return;

        this.form.setExpanded(false);
    }

    public handleViewportChanged(): void {
        this.syncByViewport();
    }

    public syncByViewport(): void {
        if (!this.isMobileViewport()) {
            this.form.setExpanded(false);
        }
    }

    public isMobileViewport(): boolean {
        return CommonUtils.isMobileViewport(992);
    }
}
